<!-- Card -->
<section class="card">
  <!-- Header -->
  <div class="card-header">
    <h3 class="card-title">
      {{ 'subscriptionModule.subscriptions' | translate }}
    </h3>
  </div>
  <!-- End Header -->
  <!-- Body -->

  <div class="card-body pb-0">
    <h4 class="card-title">{{ 'general.attached' | translate }}</h4>
  </div>
  <subscription-table
    [isLoading]="isLoading$ | async"
    (onBulkAction)="onBulkAction($event)"
    [bulkActions]="[BulkAction.DETACH]"
    [tableData]="attachedSubscriptions$ | async"
    [subscriptionTableOptions]="{
      tagsToTheEnd: true
    }"
    [showTotal]="true"
  ></subscription-table>

  <div class="card-body pb-0">
    <h4 class="card-title">{{ 'general.available' | translate }}</h4>
  </div>
  <subscription-table
    [isLoading]="isLoading$ | async"
    (onBulkAction)="onBulkAction($event)"
    [bulkActions]="[BulkAction.ATTACH]"
    [tableData]="availableSubscriptions$ | async"
    [subscriptionTableOptions]="{
      tagsToTheEnd: true
    }"
    [showTotal]="true"
  ></subscription-table>

  <!-- End Body -->
</section>
<!-- End Card -->
